import { useState } from "react";

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem("phone_alt") as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      form.reset();
      return;
    }

    const formData = new FormData(form);
    try {
      const response = await fetch("https://readdy.ai/api/form/d9qsfgvnahb7382ovesg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      if (response.ok) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        setFormError("提交失败，请稍后再试");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络错误，请检查网络连接后重试");
    }
  };

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">联系我们</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                    <p className="text-sm text-foreground-600">contact@heiliaoshequ.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">联系电话</p>
                    <p className="text-sm text-foreground-600">400-888-8888</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">公司地址</p>
                    <p className="text-sm text-foreground-600">中国北京市朝阳区建国路100号传媒大厦15层</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">工作时间</p>
                    <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-4">给我们留言</h3>
              <form
                onSubmit={handleSubmit}
                className="space-y-4"
                data-readdy-form="contact-form"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="您的邮箱"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors text-foreground-900"
                />
                <textarea
                  name="message"
                  placeholder="请输入您的留言..."
                  rows={4}
                  maxLength={500}
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none text-foreground-900"
                ></textarea>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 top-0 left-0 h-0 w-0 -z-10"
                />
                <button
                  type="submit"
                  className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg cursor-pointer transition-colors whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
              {formStatus === "success" && (
                <p className="mt-3 text-sm text-green-600">留言提交成功，我们会尽快回复您！</p>
              )}
              {formStatus === "error" && (
                <p className="mt-3 text-sm text-red-500">{formError}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}